<template>
  <div class="btnsWrapper mt-4 space-x-2.5">
    <slot />
  </div>
</template>
